import { useLocalStorage, UseStorageOptions } from "@mantine/hooks"
import { useGetAuthenticatedUser } from "./use-authenticated-user"
export function useUserLocalStorage<T>({
  key,
  getInitialValueInEffect,
  ...rest
}: UseStorageOptions<T>) {
  const {
    data: { userId },
  } = useGetAuthenticatedUser()
  return useLocalStorage<T>({
    key: `${userId}_${key}`,
    getInitialValueInEffect: getInitialValueInEffect || false,
    ...rest,
  })
}
